/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect, useContext } from 'react';

import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import Cohere from 'cohere-js';

import { AuthContext } from 'context/AuthContext';

import { ENVIRONMENT } from 'constants/config';

import { IntercomProvider as IntercomPackage } from 'react-use-intercom';

export function IntercomProvider({ children }) {
  const { cubohUser, isUserCubohOnly } = useContext(AuthContext);
  const [intercomUser, setIntercomUser] = useState(null);

  useEffect(() => {
    if (!isUserCubohOnly) {
      setIntercomUser(null);
      return;
    }
    let isSubscribed = true;

    if (
      isSubscribed &&
      cubohUser?.id &&
      import.meta.env.VITE_DEPLOY_ENV === ENVIRONMENT.production
    ) {
      setIntercomUser({
        userId: cubohUser?.intercomID,
        hideDefaultLauncher: false,
        alignment: 'right',
        horizontalPadding: 20,
        verticalPadding: 20,
        createdAt: new Date(),
        userHash: cubohUser?.intercomHmac,
      });
      Cohere.init(import.meta.env.VITE_COHERE_KEY);
      Cohere.identify(
        cubohUser?.intercomID, // Required: can be any unique ID
        {
          /*
            TODO: change the name used here to be more identifiable as the RP (restaurant name)
          */
          displayName: cubohUser?.username,
        },
      );
    }
    // eslint-disable-next-line consistent-return
    return () => {
      isSubscribed = false;
    };
  }, [cubohUser, isUserCubohOnly]);

  return (
    <IntercomPackage
      appId={import.meta.env.VITE_INTERCOM_APP_ID}
      autoBoot
      autoBootProps={{ name: cubohUser?.username, ...intercomUser }}
      shouldInitialize={!!intercomUser}
    >
      {children}
    </IntercomPackage>
  );
}

IntercomProvider.propTypes = {
  children: PropTypes.node,
};
